import React from 'react'

export default React.createContext({
  assets: [],
  filters: {},
  showMap: true,
  getAssets: (type) => {},
  updateFilters: (filters) => {},
  toggleMap: () => {},
})
